import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import { memo } from "react";
export const actionSheetLabel = tailwindVariants({
    base: "text-12 font-bold uppercase tracking-wide text-grey-10",
    variants: {
        size: {
            small: "px-1.5",
            large: "px-2"
        }
    },
    defaultVariants: {
        size: "small"
    }
});
export const ActionSheetLabel = /*#__PURE__*/ memo((param)=>{
    let { className, size = "small", ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: actionSheetLabel({
            size,
            className
        }),
        "data-testid": "ACTION_SHEET_LABEL",
        ...restOfProps
    });
});
ActionSheetLabel.displayName = "DropdownMenuLabel";
